export const environment = {
    production: false,
    OP_API_URI: 'https://pilotage-budgetaire-back-integ.appg.auchan.fr',
    OP_SOCKET_URI: 'https://pilotage-budgetaire-back-integ.appg.auchan.fr/socket.io/',
    OP_API_CAS: 'https://pilotage-budgetaire-back-integ.appg.auchan.fr/cas',
    VERSION: require('../../package.json').version,
};
